import { Link, useLocation } from 'react-router-dom';

export default function DashboardSidebar({ user }) {
  const location = useLocation();
  const currentPath = location.pathname;

  const getInitials = (name) => {
    if (!name) return '?';
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <aside className='dashboard-sidebar'>
      <div className='sidebar-brand'>
        <div className='sidebar-brand-icon'>
          <i className='bi bi-shield-check'></i>
        </div>
        <div>
          <div className='sidebar-brand-text'>AGS Seguros</div>
          <div className='sidebar-brand-sub'>Panel de Gestión</div>
        </div>
      </div>

      <div className='sidebar-user'>
        <div className='sidebar-avatar'>{getInitials(user?.usuario)}</div>
        <div className='sidebar-user-info'>
          <span className='sidebar-user-name'>{user?.usuario || 'Usuario'}</span>
          <span className='sidebar-user-role'>{user?.depto || 'Departamento'}</span>
        </div>
      </div>

      <nav className='sidebar-nav'>
        <span className='sidebar-nav-label'>Principal</span>
        <Link
          to='/dashboard'
          className={`sidebar-nav-item ${currentPath === '/dashboard' ? 'active' : ''}`}
        >
          <i className='bi bi-grid-1x2-fill'></i>
          Dashboard
        </Link>
        <Link
          to='/'
          className={`sidebar-nav-item ${currentPath === '/' || currentPath === '/tabla' ? 'active' : ''}`}
        >
          <i className='bi bi-table'></i>
          Tabla General
        </Link>

        <span className='sidebar-nav-label'>Gestión</span>
        <Link
          to='/estadisticas'
          className={`sidebar-nav-item ${currentPath === '/estadisticas' ? 'active' : ''}`}
        >
          <i className='bi bi-bar-chart-fill'></i>
          Estadísticas
        </Link>
        <Link
          to='/solicitudes'
          className={`sidebar-nav-item ${currentPath === '/solicitudes' ? 'active' : ''}`}
        >
          <i className='bi bi-file-earmark-text-fill'></i>
          Solicitudes
        </Link>
        <Link
          to='/reclamos'
          className={`sidebar-nav-item ${currentPath === '/reclamos' ? 'active' : ''}`}
        >
          <i className='bi bi-megaphone-fill'></i>
          Reclamos
        </Link>
        <Link
          to='/ampliaciones'
          className={`sidebar-nav-item ${currentPath === '/ampliaciones' ? 'active' : ''}`}
        >
          <i className='bi bi-arrows-expand'></i>
          Ampliaciones
        </Link>
        {user?.titulo === 'admin' ? (
          <Link
            to='/capturas'
            className={`sidebar-nav-item ${currentPath === '/capturas' ? 'active' : ''}`}
          >
            <i className='bi bi-camera-fill'></i>
            Capturas
          </Link>
        ) : null}

        {user?.area === 'Administracion' && (
          <>
            <span className='sidebar-nav-label'>Admin</span>
            <Link
              to='/ajustes'
              className={`sidebar-nav-item ${currentPath === '/ajustes' ? 'active' : ''}`}
            >
              <i className='bi bi-gear-fill'></i>
              Ajustes
            </Link>
          </>
        )}
      </nav>

      <div className='sidebar-footer'>
        <Link to='/login' className='sidebar-nav-item' style={{ color: '#ef4444' }}>
          <i className='bi bi-box-arrow-left'></i>
          Cerrar Sesión
        </Link>
      </div>
    </aside>
  );
}
